import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { UploadCompleteModel, UploadInitModel, UploadStoreModel } from 'src/app//models/upload.model';
import * as myGlobals from 'src/app/globals';
@Injectable({ providedIn: 'root' })
export class FileUploadService {
  completed$ = new Subject<void>();

  constructor(private http: HttpClient) {}

  multiPartInit(initObject: UploadInitModel): Observable<any> {
    return this.http.post(`${myGlobals.Config.API}/s3/upload`, initObject);
  }

  multiPartStore(storeObject: UploadStoreModel, file?: any): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/octet-stream');

    return this.http.put(`${myGlobals.Config.API}/s3/upload/${storeObject.uploadId}/${storeObject.chunkIndex}`, file, { headers, reportProgress: true, observe: 'events' });
  }

  multiPartComplete(uploadId: string, parentId: string): Observable<UploadCompleteModel> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { parentId };

    return this.http.post<UploadCompleteModel>(`${myGlobals.Config.API}/s3/upload/${uploadId}`, body, { headers }).pipe(takeUntil(this.completed$));
  }
}
